var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[(_vm.company && ! _vm.companyLoading)?_c('div',[_c('CompanyLayout',[_c('router-view')],1)],1):_vm._e(),(! _vm.company && ! _vm.companyLoading)?_c('NotFound'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }